import axios from '../../config/axiosConfig';
import { CREATE_SALES_PERSON, GET_SALES_PERSON, SALES_PERSON_REQUEST, DELETE_SALES_PERSON, 
UPDATE_SALES_PERSON, SALES_PERSON_REQUEST_FAILURE, GET_SALES_PERSON_PAGE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getSalesPersonsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_PERSON_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/sales-person/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_PERSON_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesPersons = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: SALES_PERSON_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
              }
            return axios.get('/sales-person/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_SALES_PERSON, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createSalesPerson = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { salesPersons } = getState();
            dispatch({ type: SALES_PERSON_REQUEST });

            return axios.post('/sales-person/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_SALES_PERSON, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getSalesPersonsWithPagination(
                            salesPersons.page || 1,           // current page
                            salesPersons.pageSize || 10,      // current page size
                            undefined,                  // include
                            salesPersons.search || '',        // current search
                            undefined,                  // searchCols
                            salesPersons.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('salesPersons', response.data));
                    } else {
                        dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: 'Sales Person create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateSalesPerson = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { salesPersons } = getState();
            dispatch({ type: SALES_PERSON_REQUEST });
            return axios.put('/sales-person/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_SALES_PERSON, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getSalesPersonsWithPagination(
                        salesPersons.page || 1,           // current page
                        salesPersons.pageSize || 10,      // current page size
                        undefined,                  // include
                        salesPersons.search || '',        // current search
                        undefined,                  // searchCols
                        salesPersons.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('salesPersons', id, response.data));
                } else {
                    dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: 'Sales Person update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteSalesPerson = (id) => {
    return async (dispatch, getState) => {
        try {
            const { salesPersons } = getState();
            dispatch({ type: SALES_PERSON_REQUEST });
            return axios.delete(`/sales-person/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_SALES_PERSON, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getSalesPersonsWithPagination(
                        salesPersons.page || 1,           // current page
                        salesPersons.pageSize || 10,      // current page size
                        undefined,                  // include
                        salesPersons.search || '',        // current search
                        undefined,                  // searchCols
                        salesPersons.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('salesPersons', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: SALES_PERSON_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};